"use strict";
/**
 * @description 背景颜色 BackColor
 * @author lkw
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DropListMenu_1 = __importDefault(require("../menu-constructors/DropListMenu"));
var dom_core_1 = __importDefault(require("../../utils/dom-core"));
var BackColor = /** @class */ (function (_super) {
    __extends(BackColor, _super);
    function BackColor(editor) {
        var _this = this;
        var $elem = dom_core_1.default("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-paint-brush\"></i>\n            </div>");
        var colorListConf = {
            width: 120,
            title: '背景颜色',
            // droplist 内容以 block 形式展示
            type: 'inline-block',
            list: editor.config.colors.map(function (color) {
                return {
                    $elem: dom_core_1.default("<i style=\"color:" + color + ";\" class=\"w-e-icon-paint-brush\"></i>"),
                    value: color,
                };
            }),
            clickHandler: function (value) {
                // this 是指向当前的 BackColor 对象
                _this.command(value);
            },
        };
        _this = _super.call(this, $elem, editor, colorListConf) || this;
        return _this;
    }
    /**
     * 执行命令
     * @param value value
     */
    BackColor.prototype.command = function (value) {
        var editor = this.editor;
        editor.cmd.do('backColor', value);
    };
    /**
     * 尝试修改菜单激活状态
     */
    BackColor.prototype.tryChangeActive = function () { };
    return BackColor;
}(DropListMenu_1.default));
exports.default = BackColor;
